export const queries = {
  auditLog: (orderId: number) => ['shop-orders', orderId, 'audit-log'],
}
